import debug from 'webmd-debug';
import cookie from 'webmd-cookie';

if (typeof window !== 'undefined') {

    (function () {
        try {
            //Disable vendor if url containts vendor=0 or blockThrough=0
            var url = (document.referrer) ? document.referrer : document.location.href;
            if (url && (url.indexOf('vendor=0') > -1 || url.indexOf('bt=0') > -1)) {
                return false;
            }
            //Disable blockthrough on webmdrx pages
            if (window.location.host.includes('webmdrx')){
                return false;
            }

            // Disable vendor based on ads admin tool data
            if(window.globalConfig && window.globalConfig.ads) {

                let vendorConfig = window.globalConfig.ads.vendorConfig;
                let btConfig = vendorConfig.blockThrough ? vendorConfig.blockThrough : {};
                let location = cookie.getJson('gtinfo');

                /**
                 *  Gtinfo cookie stores country code in lowercase while admin tool db stores in uppercase
                 *  hence text transform is done.
                 */
                let isLocationAdded = false;
                let countryCode = location.cntr ? location.cntr.toUpperCase() : '';
                let locationList = btConfig.location ? btConfig.location : [];

                /** 
                 *  If the gtinfo is not available and only some of the locations are selelcted, 
                 *  location based vendor suppression cannot be done properly. Hence, vendors can be loaded 
                 *  as default behavior. 
                 * 
                 *  If location property is undefined or no countries are added in location array 
                 *  or all the countries are selected, then it can be considered as 
                 *  all the locations are selected and not required to check for gtinfo.
                 *  Countries available in WebMD gtinfo file : 249
                 */
                if ( !(countryCode == '' && locationList.length > 0 && locationList.length < 249) ) {
                    if ( locationList.length == 0 || locationList.length == 249 || locationList.includes(countryCode) ) {
                        isLocationAdded = true;
                    }
                    /**
                     *  If disable is true and the location is included in the location array, 
                     *  then vendor should not be loaded.   
                     *  If disable is set to false and certain countries are added in location array, 
                     *  then for the countries that are not added in the array can be considered 
                     *  to have disable : true and vendor should not be loaded in this case. 
                     */
                    if (btConfig.disable && isLocationAdded) {
                        return false;
                    } else if ( !(btConfig.disable) && !isLocationAdded ) {
                        return false;
                    }
                }
            }

            // create faux ad
            let adBlockerDiv = document.createElement("div");
            adBlockerDiv.className = "advertisement-swimlane advertisement-tag advertisement-text advertisement-top advertisement-txt advertisement-wrapper advertisement1 advertisement300x250 advertisement468 advertisementBackground advertisementBannerVertical advertisementBar advertisementBlock advertisementBox advertisementCenterer advertisement-right advertisement-right-rail advertisement-sidebar advertisement-space advertisement-sponsor";
            adBlockerDiv.innerHTML = "advertisement";
            adBlockerDiv.style.visibility = "hidden";
            document.body.appendChild(adBlockerDiv);

            // non-blocking detection
            setTimeout(function () {
                window.adBlocker = adBlockerDiv.clientHeight === 0 || adBlockerDiv.offsetHeight === 0 || adBlockerDiv.clientWidth === 0 || adBlockerDiv.offsetWidth === 0;
                debug(`Ad Blocker ${window.adBlocker ? 'Present' : 'Absent'}`);
                document.body.removeChild(adBlockerDiv);
            }, 0);

            // add event listener to load Blockthrough Script
            document.addEventListener('BLOCKTHROUGH_SETUP', () => {
                // load bt script
                const btScript = document.createElement("script");
                const btScriptPath = "https://btloader.com/tag?o=5190751846137856&upapi=true";
                btScript.setAttribute("src", btScriptPath);
                btScript.async = true;
                document.head.appendChild(btScript);
                window.webmd.createBeaconCall("webmd-vendor-flow", "webmd-blockthrough", "webmd-blockthriugh-loaded");
            });

        } catch (error) {
            debug("Ad Block Detection Failed")
        }

    })();
};

